export default __webpack_public_path__ + "static/media/card_blog.baf07cba.jpg";